<template>
    <div class="result">
        <!-- Webinar Banner -->
        <div class="webinar" v-if="state != 'in-processing'">
            <div class="webinar-inner">
                <img class="webcam" :src="WebCam" alt="WebCam">
                <span>در حال حاضر هیچ وبیناری در جریان نیست.</span>
            </div>
        </div>
        <div class="webinar" v-else>
            <a 
                :href="link"
                class="webinar-cover"
                :style="{ 'background-image': 'url(' + URL + '/' + cover + ')' }"
            ></a>
        </div>

        <div class="desc" v-if="state == 'progressive'">
            <span>وبینار بعدی:</span>
            <span class="title">{{ title }}</span>
        </div>
        <div class="desc" v-else-if="state == 'in-processing'">
            <span>وبینار جاری:</span>
            <span class="title">{{ title }}</span>
        </div>

        <div class="time-counter" :key="durationKey" v-if="state == 'progressive' && duration">
            <div>
                <span>{{ duration.years() * 365 + duration.months() * 30 + duration.days() }}</span>
                <span>روز</span>
            </div>
            <div>
                <span>{{ duration.hours() }}</span>
                <span>ساعت</span>
            </div>
            <div>
                <span>{{ duration.minutes() }}</span>
                <span>دقیقه</span>
            </div>
            <div>
                <span>{{ duration.seconds() }}</span>
                <span>ثانیه</span>
            </div>
        </div>
    </div>
</template>

<script>
import zzz from '@/assets/images/resaneh/zzz.png';
import WebCam from '@/assets/images/resaneh/webcam.png';

import moment from 'moment';

import { getRequest, APP_API_URL } from '@/utils/libs/api-request';
import Cookies from 'js-cookie';

export default {
    name: 'Webinar',
    data() {
        return {
            zzz: zzz,
            WebCam: WebCam,

            URL: APP_API_URL(),

            id: undefined,
            title: undefined,
            link: undefined,
            cover: undefined,
            eventDate: undefined,
            expireDate: undefined,

            state: 'none',
            duration: undefined,
            durationKey: 1,
        }
    },
    mounted() {
        this.getCurrent()
    },
    methods: {
        getCurrent() {
            getRequest('/webinars/find-top')
                .then((rsp) => {
                    let data = rsp['data'][0]

                    if(!data.isRemoved) {
                        this.id = data._id;
                        this.title = data.Title;
                        this.cover = data.Cover;
                        this.eventDate = moment(data.EventDate, 'YYYY/MM/DD HH:mm');
                        this.expireDate = moment(data.ExpireDate, 'YYYY/MM/DD HH:mm');

                        if(data.Link.indexOf('http') == 0) { this.link = data.Link; }
                        else { this.link = 'http://' + data.Link; }

                        let now = moment();

                        if (now.isSameOrBefore(this.expireDate) && now.isSameOrAfter(this.eventDate)) {
                            this.state = 'in-processing';
                        }
                        else if (now.isSameOrBefore(this.expireDate) && now.isSameOrBefore(this.eventDate)) {
                            this.state = 'progressive';

                            let interval = 1000;
                            let diffTime = this.eventDate.diff(now, 'milliseconds') ;

                            let duration = moment.duration(diffTime, 'milliseconds');
                            this.duration = moment.duration(duration);

                            setInterval(function(){
                                duration = moment.duration(duration - interval, 'milliseconds');
                                this.duration = moment.duration(duration);

                                this.durationKey++;
                            }.bind(this), interval);
                        }
                        else this.state = 'none';
                    } else {
                        this.reset();
                        this.edit = false;
                    }
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' })
                        } else {
                            this.reset();
                            this.edit = false;
                        }
                    }
                });
        },
    }
}
</script>

<style scoped>
/* ---------------------------------------- */
/* ---------------- GENERAL --------------- */
/* ---------------------------------------- */
.result {
    height: calc(100vh - 50pt);

    display: flex;
    flex-direction: column;

    border-bottom-right-radius: 9vh;
    border-bottom-left-radius: 9vh;
    background-color: #ebecf1;
}

/* ---------------------------------------- */
/* ------------ WEBINAR BANNER ------------ */
/* ---------------------------------------- */
.result .webinar {
    min-height: 40vw;
    width: 90vw;
        
    margin: auto;
    margin-top: 5vh;
    padding: 10pt;

    border: 2px solid #fff;
    border-radius: 20pt;
    background-color: #ebecf1;
    box-shadow: inset 2.2px 2.2px 4px #c3c5c7;
}
.result .webinar .webinar-inner {
    height: 100%;
    width: 100%;

    padding-bottom: 5vh;

    position: relative;
    display: flex;
    flex-direction: column;

    border-radius: 15pt;
    background-color: #fff;
}
.result .webinar .webinar-cover {    
    height: 100%;
    width: 100%;

    padding-bottom: 5vh;

    position: relative;
    display: inline-block;
    
    border-radius: 15pt;
    background-color: #fff;

    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
.result .webinar .webinar-inner .webcam {
    max-height: 25vh;
    max-width: 70%;
    margin: 5vh auto;
}
.result .webinar .webinar-inner span {
    margin: 0 auto;
    display: inline-block;

    color: #3c3e47;
    font-weight: bold;
}

.result .desc {
    margin-bottom: auto;
    text-align: center;
    color: #3c3e4799;
}
.result .desc .title {
    margin-right: 3pt;
    display: inline-block;

    color: #3c3e47;
}

/* ---------------------------------------- */
/* ------------- TIME COUNTER ------------- */
/* ---------------------------------------- */
.result .time-counter {
    width: 65%;
    max-width: 275pt;
    margin: 0 auto auto;
    display: flex;
    flex-direction: row;
}
.result .time-counter div {
    width: calc(25% - 5pt);
    margin: 15pt auto 0pt;
    padding: 7pt 0;

    display: flex;
    flex-direction: column;

    background-color: #2ad85f;
    border-radius: 12pt;
    box-shadow: inset 1.5px 2.6px 3px 0px #2ad85f;
}
.result .time-counter span {
    margin: 0 auto;

    font-size: 1rem;
    color: #fff;
    font-weight: bold;
}

/* ---------------------------------------- */
/* -------------- RESPONSIVE -------------- */
/* ---------------------------------------- */
@media (max-width: 576px) {
    /* webinar banner */
    .result .webinar {
        margin-top: 3vh;
    }
    .result .webinar .webinar-inner {
        padding-bottom: 3vh;
    }
    .result .webinar .webinar-inner .webcam {
        margin: 3vh auto;
    }
    .result .webinar .webinar-inner span {
        font-size: .7rem;
    }

    /* time counter */
    .result .time-counter div {
        margin: 10pt auto 0pt;
        padding: 5pt 0;
    }
    .result .time-counter span {
        font-size: .9rem;
    }
}
</style>